export default {
  banners:[
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
      {
        imgUrl: require('../../../assets/images/services/banner-08.jpg'),
        title: 'ビジネスプロセスアウトソーシング（BPO）',
        description: '',
        component: ''
      }
  ],
  items:[
    {
      title: 'ビジネスプロセスアウトソーシング',
      description: `<p style="font-size:1.05rem">
     現在の経済グローバル化は新たな発展段階に入り、産業の国際移転は製造業からサービス業へと広がっています。サービス業のアウトソーシングはグローバル化発展の重要なトレンドです。企業がBPOモデルを採用して補助業務を経験豊富な専門の第三者企業に委託することで、コア事業の競争力を高めることができます。BPOの利点は次の通りです。
      </p>
      <p>
    BPOはあらゆる業界に適用でき、企業の成長を加速させます。補助業務がコア業務をより効果的に支援することで、全体の収益性が向上します。企業はコア業務により注力でき、補助業務の有効な管理を実現できます。新しい市場環境の下で従来の業界の境界を越え、外部企業と跨る事業連携を構築し、長期的な戦略的パートナーシップを形成して相互の競争力を高めます。また、企業の生産コストを管理・削減することに寄与します。
      </p>`
    },
    {
      title: '当社のサービスと強み',
      description: `<span class='img' style="background:url(`+require('../../../assets/images/services/pic-08.jpg')+`)"></span>
      <span class="list">
      <i></i>長年にわたるアウトソーシング経験に基づき、顧客の状況と国の方針を考慮した最適な提案を策定します。<br/>
      <i></i>管理効率の総合的向上を支援します。<br/>
      <i></i>コスト管理を支援します。<br/>
      <i></i>企業のコア事業能力の強化を支援します。<br/>
      </span>`
    }
  ]
}
